export default __webpack_public_path__ + "static/media/04.abcc6141.jpg";